const excludedAuthPaths = ['/login', '/logout', '/otp/login', '/otp/redirect']

export default defineNuxtRouteMiddleware((_to: any, _from: any) => {
  const userStore = useUserStore()

  if (!userStore.isLoggedIn && !excludedAuthPaths.some((path) => _to.path.includes(path))) {
    return navigateTo('/login')
  }
})
